const LogoIcon = () => {
  return (
    <img
      src="/logos/SCALAR-logo.svg"
      width={70}
      alt="SCALAR icon"
      style={{ marginLeft: '-1.3rem' }}
    />
  );
};

export default LogoIcon;
